// Used in reset-problem-dialog.component.ts, lti-iframe.component.ts, skip-problem-dialog.component.ts, student-profile.component.ts

import { Injectable } from "@angular/core";
import { Asset } from "@carnegie-learning/cure-types";
import {
    PPAssignment as Assignment,
    CompositeTaskAssignment,
} from "cli-types";

@Injectable()
export class LtiHelper {
    constructor() {}

    // Generate Sync ID for Math LTI launches
    public getSyncID(
        assignment: Assignment | CompositeTaskAssignment,
        linkedAsset?: Asset
    ) {
        // For Bundle assignment case, the assignmentID is the bundle, the assetId is the task.
        // The PP API searches for the assignmentID, checks if it's a Bundle, and uses the assetId to get the compositeTaskAssignment for syncing
        // This is more straightforward for non-bundled assets. The PP API looks fetches the assignment and syncs what it needs.
        let assetId = assignment.assetId;
        if (linkedAsset) {
            assetId = linkedAsset.assetId;
        }
        return assignment.assignmentID + ":" + assetId;
    }
}
